/* istanbul ignore file */
import { css } from 'styled-components';
import { DRAWER_HEIGHT_CSS_VAR } from "../constants/cssVariables";
export var container = /*#__PURE__*/css(["display:flex;flex-direction:column;height:var(", ");min-height:100%;"], DRAWER_HEIGHT_CSS_VAR);